var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect, _path39;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReefer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 18,
    viewBox: "0 0 78 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.304.418H.669v16.72h76.635V.418z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.523.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.422.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.973.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.606.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.507.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.055.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.691.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.59.8h-.899v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.14.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.774.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.674.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.224.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.857.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.756.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.307.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.94.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.84.8h-.899v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.39.8h-.899v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.023.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.923.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.476.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.108.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.007.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.557.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.192.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.092.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.64.8h-.899v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.277.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.176.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.725.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.358.8h-.899v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.26.8h-.899v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.81.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.443.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.342.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.894.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.527.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.427.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.978.8h-.899v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.61.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.512.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.062.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.695.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.595.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.144.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.778.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.68.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.228.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.862.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.764.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.312.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.944.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.847.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.397.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.03.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.929.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.48.8h-.899v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.113.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.014.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.565.8h-.899v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.198.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.098.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.65.8h-.9v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.281.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.18.8h-.899v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.731.8h-.899v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.365.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.266.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.815.8h-.899v15.957h.9V.799z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.45.8h-.9v15.957h.9V.799z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.349.8h-.9v15.957h.9V.799z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.897.8h-.899v15.957h.9V.799z",
    fill: "#757575"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.567 16.36H1.914v.783h74.653v-.783z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.276.74H.886v15.62h1.39V.74z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.062.72H.672V16.6h1.39V.72z",
    fill: "#757575"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.603.347H.88V.76h75.723V.347z",
    fill: "#757575"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.064.09H.536v.926h1.528V.09z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.315.346v.82H.669v-.15H.65V.174h1.41v.172h.254z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.064.128H.588v.888h1.476V.128z",
    fill: "#757575"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.008.128H.588V.98h1.42V.128z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.199.817a.262.262 0 0 0 .239-.16.26.26 0 0 0-.025-.244.252.252 0 0 0-.297-.075.26.26 0 0 0-.159.238.26.26 0 0 0 .044.145.25.25 0 0 0 .198.096z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.061 16.256H.533v.924h1.528v-.924z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.257 16.36h-.343v.783h.343v-.783z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.064 16.22H.674v.234h1.39v-.234z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.061 16.292H.588v.888H2.06v-.888z",
    fill: "#757575"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.008 16.292H.588v.85h1.42v-.85zM77.998.72h-1.39V16.6h1.39V.72z",
    fill: "#757575"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78 .09h-1.528v.925H78V.09z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78 .347h-1.533v.835H78V.347z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.998.128h-1.474v.888h1.474V.128z",
    fill: "#757575"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77.945.128h-1.42V.98h1.42V.128z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.995 16.198h-1.608v.946h1.608v-.946z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M78 16.256h-1.528v.924H78v-.924z",
    fill: "#757575"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M77.998 16.292h-1.474v.888h1.474v-.888z",
    fill: "#757575"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M77.945 16.292h-1.42v.85h1.42v-.85z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.199 16.983a.263.263 0 0 0 .239-.16.268.268 0 0 0-.025-.244.253.253 0 0 0-.297-.075.261.261 0 0 0-.159.24c0 .051.016.102.044.145a.255.255 0 0 0 .198.094zM77.131 16.983a.26.26 0 0 0 .213-.405.252.252 0 0 0-.296-.075.259.259 0 0 0-.117.386.254.254 0 0 0 .2.094zM77.131.817a.26.26 0 0 0 .213-.404.252.252 0 0 0-.296-.076.259.259 0 0 0-.117.384.25.25 0 0 0 .2.096zM14.021 16.494h-3.67v.505h3.67v-.505zM68.13 16.494h-3.67v.505h3.67v-.505z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.533,
    y: 2.09,
    width: 14.784,
    height: 14.002,
    rx: 2,
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.622 8.612a.462.462 0 0 0 .466-.797h-.002l-1.026-.593 1.086-.631c.22-.13-.243-.927-.463-.798l-1.087.63V5.239c0-.259-.927-.259-.927 0v1.71l-1.474.85-.866-.486v-1.71l1.49-.858c.22-.13-.244-.927-.464-.798l-1.026.592V3.284c0-.258-.927-.258-.927 0v1.254l-1.026-.592c-.22-.13-.683.676-.464.798l1.49.858v1.71l-.867.487-1.467-.851V5.222c0-.258-.927-.258-.927 0v1.186l-1.086-.63c-.22-.13-.683.676-.464.797l1.087.631-1.026.593c-.22.129.243.927.463.798l1.49-.859 1.474.851v.996l-1.474.858-1.49-.858c-.22-.13-.683.676-.463.798l1.026.592-1.087.631c-.22.13.244.927.464.798l1.086-.63v1.185c0 .259.927.259.927 0v-1.725l1.474-.851.867.486v1.71l-1.49.859c-.22.129.244.927.464.798l1.026-.593V14.9c0 .258.927.258.927 0v-1.254l1.026.592c.22.13.683-.676.463-.798l-1.49-.858v-1.712l.867-.486 1.474.85v1.726c0 .259.927.259.927 0v-1.186l1.087.631c.22.13.683-.676.463-.798l-1.086-.63 1.026-.593c.22-.13-.244-.927-.464-.798l-1.497.858-1.474-.85v-.996l1.482-.851 1.482.866zm-3.731 1.079-.464.258-.099.053-.463.259-.464-.259-.099-.053-.463-.258V8.498l.463-.258.1-.053.463-.259.463.259.1.053.463.258v1.193z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReefer);
export default __webpack_public_path__ + "static/media/reefer.05bbb10c699282d949cbacf15dd865b5.svg";
export { ForwardRef as ReactComponent };